import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { NgMatModule } from '@shared/modules/ngmat.module';
import { LayoutModule } from 'src/app/_layout/layout.module';
import { VoiceComponent } from './voice.component';
import { VoiceRecordComponent } from './voice-record/voice-record.component';
import { VoiceVisualiserComponent } from './voice-visualiser/voice-visualiser.component';
import { MediaAccessComponent } from './media-access/media-access.component';
import { MediaErrorComponent } from './media-error/media-error.component';
import { I18nModule } from '@shared/i18n/i18n.module';
import { DomModule } from '@shared/dom';
import { MediaRecorderModule } from '../media-recorder/media-recorder.module';
import { MatIconModule } from '@angular/material/icon';
import { HelpVideoDialogComponent } from './help-video-dialog/help-video-dialog.component';
import { MicrophoneTroubleshootDialogComponent } from './microphone-troubleshoot-dialog/microphone-troubleshoot-dialog.component';
import { VoiceRecordButtonComponent } from './voice-record-button/voice-record-button.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NgMatModule,
    LayoutModule,
    I18nModule,
    DomModule,
    MediaRecorderModule,
    MatIconModule,
  ],
  declarations: [
    VoiceComponent,
    VoiceRecordComponent,
    VoiceVisualiserComponent,
    MediaAccessComponent,
    MediaErrorComponent,
    HelpVideoDialogComponent,
    MicrophoneTroubleshootDialogComponent,
    VoiceRecordButtonComponent,
  ],
  exports: [
    VoiceComponent,
    VoiceRecordComponent,
  ],
})
export class VoiceCheckModule { }
